import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  useSnackbar,
} from '@rrexpress/core';

import { BaseShow } from '@/components/show';
import { DataDisplay } from '@/components/show/data-display';
import useLayout from '@/hooks/useLayout';
import { useModal } from '@/hooks/useModal';
import useInvoice from '@/modules/invoice/application/invoice';
import { convertNumberToCurrency } from '@/utility/helper/common';
import { isValidDateString } from '@/utility/helper/dateUtils';
import dayjs from 'dayjs';
import { IInvoiceAwb } from '@/modules/invoice/model/invoice';
import InvoiceTable from './table/invoice';
import InvoicePaymentTable from './table/payment';
import InvoiceReceiptTable from './table/receipt';

const InvoiceDetail = () => {
  useLayout({ title: 'Invoice' });

  const [dataInvoiceAwb, setDataInvoiceAwb] = useState<IInvoiceAwb[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams<{ id: string }>();
  const { show } = useSnackbar();

  const { getInvoiceById, getInvoiceAwbById } = useInvoice();
  const { data, isLoading: isLoadingDetail } = getInvoiceById(id as string);

  const modal = useModal();

  function showDetailPayment() {
    modal.open({
      title: 'Detail Payment',
      template: <InvoicePaymentTable id={id as string} />,
      width: 1000,
    });
  }

  function showDetailReceipt() {
    modal.open({
      title: 'Detail Resi',
      template: <InvoiceReceiptTable record={data} />,
      width: 1500,
    });
  }

  function getDetailInvoiceAwb() {
    setIsLoading(true);
    getInvoiceAwbById(id as string)
      .then((res) => {
        setDataInvoiceAwb(res?.data);
      })
      .catch((res) => {
        show(res?.err, 'error');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getDetailInvoiceAwb();
  }, []);

  return (
    <div className="w-[50vw] m-auto">
      <BaseShow
        title="Invoice"
        isLoading={isLoadingDetail || isLoading}
        resource="invoices"
        // id={id as string}
      >
        <>
          <div className="mb-4">
            <div className="grid grid-cols-2 gap-x-8 mb-6">
              <div className="flex flex-col gap-y-4 mb-8">
                <DataDisplay
                  label="Customer"
                  value={data?.data?.customer_name}
                />
                <DataDisplay
                  label="No Telepon"
                  value={data?.data?.phone_number}
                />
                <DataDisplay
                  label="Alamat"
                  value={data?.data?.address_street}
                />

              </div>
              <div className="flex flex-col gap-y-4 mb-8">
                <DataDisplay
                  label="No Invoice"
                  value={data?.data?.invoice_number}
                />
                <DataDisplay
                  label="Tanggal Invoice"
                  value={isValidDateString(data?.data?.invoice_date_time_utc) ? dayjs(data?.data?.invoice_date_time_utc).format('DD MMMM YYYY') : '-'}
                />
                <DataDisplay
                  label="Tgl Jatuh Tempo"
                  value={isValidDateString(data?.data?.invoice_due_date_time_utc) ? dayjs(data?.data?.invoice_due_date_time_utc).format('DD MMMM YYYY') : '-'}
                />

              </div>
            </div>
          </div>

          <div>
            <InvoiceTable
              data={dataInvoiceAwb}
              onShowReceipt={() => showDetailReceipt()}
            />
          </div>

          <div className="w-full">
            <div className="flex justify-end space-x-4">
              <div className="text-left space-y-2">
                <p>Subtotal</p>
                <p>Diskon (10%)</p>
                <p>Pajak (11%)</p>
                <p>Total</p>
                <p>Bayar</p>
                <p>Balance</p>
              </div>
              <div className="text-right space-y-2">
                <p>:</p>
                <p>:</p>
                <p>:</p>
                <p>:</p>
                <p>:</p>
                <p>:</p>
              </div>
              <div className="text-right space-y-2">
                <p>{convertNumberToCurrency(data?.data?.subtotal as number)}</p>
                <p>{convertNumberToCurrency(data?.data?.discount_amount as number)}</p>
                <p>{convertNumberToCurrency(data?.data?.tax_amount as number)}</p>
                <p>{convertNumberToCurrency(data?.data?.total as number)}</p>
                <p
                  className="text-blue-500 cursor-pointer"
                  onClick={() => {
                    showDetailPayment();
                  }}
                >
                  {convertNumberToCurrency(data?.data?.total_paid as number)}
                </p>
                <p>{convertNumberToCurrency(data?.data?.outstanding_amount as number)}</p>
              </div>
            </div>
          </div>
        </>
      </BaseShow>
    </div>
  );
};

export default InvoiceDetail;
